import { getLocalizedString } from "@icarius-localization/strings";
import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (data, createCallback, invalidDataCallback) => {
  const createInitialData = () => {

    const getInitialFieldData = () => {
      if (data.evaluationStatus === 'K') return getLocalizedString("willInformFeedbackStarted", { processName: data.processName });
      return getLocalizedString("willInformProcessStarted", { processName: data.processName });
    }

    const fieldNames = [
      "message",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const dataIsValid = async () => {
    const schema = yup.object().shape({
      'message': yup.string().required(),
    });

    return await schema.isValid(formData).then((valid) => valid);
  }

  const submit = async () => {
    if (await dataIsValid()) {
      createCallback({
        processCode: data.processCode,
        message: formData.message,
      });

      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    })
  }

  return {
    formData,
    setFormValue,
    submit,
  };
}

export default useHandleForm;
